var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeadDecorationCl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 372.8 68.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#_\u540D\u79F0\u672A\u8A2D\u5B9A\u30B0\u30E9\u30C7\u30FC\u30B7\u30E7\u30F3_63);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u540D\\u79F0\\u672A\\u8A2D\\u5B9A\\u30B0\\u30E9\\u30C7\\u30FC\\u30B7\\u30E7\\u30F3_63",
    x1: 3803.53,
    y1: 201.14,
    x2: 3803.8,
    y2: 201.23,
    gradientTransform: "translate(-4392570.39 639906) rotate(-8) scale(1167.05 -110.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#370404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#4a0202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#6f0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d0000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,68.63L372.8,0l-114.24,52.34L0,68.63Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadDecorationCl);
export default __webpack_public_path__ + "static/media/head_decoration_cl.adf2609d008ace375d4e5b820d508ac0.svg";
export { ForwardRef as ReactComponent };